<template>
  <div>
    <InfoBox v-if="data && data.length > 0">
      {{ $t('communication.newsListInfo') }}
    </InfoBox>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      :moduleName="`communication.newsChannels`"
    >
      <template v-slot:item.action="{ item }">
        <DeleteButton
          icon="fad fa-trash"
          :title="$t('global.delete')"
          @click.native="openDeleteHandler(item)"
        ></DeleteButton>
      </template>
    </List>

    <DeleteOperation
      :url="deleteOperationUrl"
      :params="deleteOperationParams"
      @updateList="getList"
    />
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'NewsChannels',
  data() {
    return {
      loading: false,
      header: [
        { text: 'global.name', value: 'name', clicked: false },
        { text: 'global.actions', value: 'action', size: '75px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      deleteOperationParams: '',
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'communication.communicationChannels',
        route: '/communication/communication-channels',
      },
      {
        title: 'communication.newsChannels',
        route: '/communication/news-channels',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'communication.communication',
        },
        {
          title: 'communication.newsChannels',
          route: '/communication/news-channels',
        },
      ],
      showDetailButton: false,
      showSearch: false,
    })
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `crm/me/marketing-lists?position=id|desc&page=${
        current_page ? current_page : 1
      }`
      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `crm/me/marketing-lists/unsubscribe`
      this.deleteOperationParams = { marketing_list_id: item.id }
      this.$bvModal.show('modal-deleteOperation')
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.info-box {
  align-items: center !important;
  background: #fff;
}
</style>
